<template>
  <div>
    <div class="mm-page">
      <mmheader :sortnav="sortnav" @gotohome="gotohome" @changenavsize="changenavsize"></mmheader>
      <div class="mm-body">
        <mmnav class="pcshow" :gohome="gohome" :sortnav="sortnav"></mmnav>
        <mmmain></mmmain>
      </div>
    </div>
  </div>
</template>

<script>
import mmpublic from '@/views/Public/Index.vue';
import mmheader from "./components/Header.vue";
import mmnav from "./components/Nav.vue";
import mmmain from "./components/Main.vue";
export default {
  components: {
    mmheader,
    mmnav,
    mmmain
  },
  data () {
    return {
      gohome: false,
      sortnav: false
    };
  },
  methods: {
    changenavsize (sortnav) {
      // console.log(sortnav);
      localStorage.setItem('sortnav',sortnav);
      this.sortnav = sortnav;
      // console.log(localStorage.getItem('sortnav'));
    },
    gotohome (go) {
      this.gohome = Math.random();
    },
	
  },
  created(){
    this.sortnav = localStorage.getItem('sortnav')=='false'?false:true;
  }
};
</script>

<style scoped>
@media (max-width: 768px) {
  .pcshow {
    display: none;
  }
}
</style>